module.exports = "<ul v-bind:class=\"{'list-group': true, 'list-group-flush': flush}\">\n  <slot></slot>\n</ul>";


//////////////////
// WEBPACK FOOTER
// ./src/components/list-group/list-group.html
// module id = 50
// module chunks = 0